import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import colors from "../../constants/colors";
import SearchInventory from "./searchInventoryTypes";
import SearchIngredientsByLot from "./searchIngredientsByLot";
import { getIngredientLotsByName } from "../../actions/submissions";
import { getLotCodeString, getComponentSubmit, getComponentByanotherComponentId, getComponentSubmissionByDefaultLabel, getTotalSelected, getComponentDefaultSubmit, validateDecimals, formatStringNumber } from "../../utils";
import LotsByLocation from "../widgets/LotsByLocation";
let _interval = null;

class LotCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initial,
      dialogVisible: false,
      height: 30,
      reset: false,
      ingredientOptions: (props.complete_date && props.isRecipe && props.options) ? props.options : [],
      ingredientName: "",
      showLotsByLocation: false,
      leftWriting: true,
      loadingBatchSizeChange: false
    };
    this.textInputRef = createRef(null);
  }
  componentDidMount() {
    const { showInventorySearch, isRecipe, components, position, submission, defaultLabel, section_id, showWipSearch, isInvoice, isInventoryTransfer, isShipmentLog, newReport, status, initial, id, updateComponentLotCodeschoiceList, complete_date } = this.props;
    if ((showInventorySearch || showWipSearch || (isShipmentLog && defaultLabel == "lotcode")) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog) && !(isRecipe && complete_date)) {
      var sectionComponent = components ? components.find((c, idx) => (c?.type == "section") && (section_id == c.section_id)) : null;
      var ingredientComponent = components ? components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id)) : null;
      var ingredientName = "";
      if (ingredientComponent?.length > 0) {
        var ingredientComponentId = ingredientComponent[0].id;
        if (submission[ingredientComponentId]) {
          if (submission[ingredientComponentId][position]) {
            ingredientName = submission[ingredientComponentId][position];
            if (ingredientName && ingredientName != this.state.ingredientName) {
              var data = {
                name: ingredientName,
                type: (ingredientComponent[0]?.defaultLabel == "ingredient" || ingredientComponent[0]?.defaultLabel == "itemName") ?
                  showWipSearch ?
                    "wip" : "ingredient" : ((isInventoryTransfer || isShipmentLog) && ingredientComponent[0]?.defaultLabel == "item") ?
                    sectionComponent?.defaultLabel == "finishedGoods" ?
                      "fg" : sectionComponent?.defaultLabel == "workInProgress" ?
                        "wip" : sectionComponent?.defaultLabel == "packagingMaterials" ?
                          "packagingMaterial" : "ingredient" : isInvoice ?
                      "fg" : "packagingMaterial"
              }
              if (isRecipe) data.forRecipe = true;
              this.setState({ ingredientName });
              this.props.getIngredientLotsByName(data, (res) => { 
                if (res?.lots?.length) {
                  var val = [];
                  this.setState({ ingredientOptions: res.lots }, () => {
                    //Save actual lotcodes in component choice list
                    if(updateComponentLotCodeschoiceList)updateComponentLotCodeschoiceList(id, res.lots, position);
                  });
                  //Set First lot code as prefilled data
                  var initialValue = initial ? initial : "";
                  if ((!status || status == "in_progress") && !isShipmentLog && (!initial || typeof initial == "object" && initialValue[0] == "default_lot")) {
                    var p = (position + 1) * 300;
                    //val.push(res.lots[0]);
                    val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(res?.lots)));

                    //Wait to submission be updated correctly
                    //if (!isInvoice)
                      setTimeout(() => {
                        this.onSelectItem(val, true);
                      }, p);
                  }
                }
              });
            }
          }
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showInventorySearch, isRecipe, components, position, defaultLabel, section_id, showWipSearch, isInvoice, isInventoryTransfer, isShipmentLog, id, onChange, focusLotCode, handleFocusOnElement, complete_date } = this.props;
    const { submission, quantityChangedPosition } = nextProps;
    const { ingredientOptions } = this.state;
    if (nextProps.initial != this.props.initial) {
      this.setState({ value: nextProps.initial });
    }
    if(isRecipe && nextProps.focusLotCode != focusLotCode && nextProps.focusLotCode && defaultLabel == "lot" && position == 0){
      if (this.textInputRef.current) {
        setTimeout(() => {
          this.textInputRef.current.focus();
        }, 500);
      }
    }
    if (nextProps?.resetInventorySearch) {
      if ((nextProps?.resetInventorySearch?.changed != this.props.resetInventorySearch?.changed && nextProps?.resetInventorySearch?.position == this.props?.position && (isShipmentLog || isInventoryTransfer) && (this.props?.defaultLabel == 'lotcode_finished' || this.props?.defaultLabel == 'lotcode_wip' || this.props?.defaultLabel == 'lotcode'))) {
        this.setState({ value: nextProps.initial, reset: !this.state.reset, ingredientOptions: [] });
      }
    }
    var ingredientComponent = components ? components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "packagingMaterial" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id)) : null;
    if (ingredientComponent?.length > 0) {
      var ingredientComponentId = ingredientComponent[0].id;
      if (submission[ingredientComponentId]) {
        if (!submission[ingredientComponentId][position] && submission[ingredientComponentId][position] != this.state.ingredientName) {
          this.setState({ ingredientName: "" });
        }
      }
    }
    //Show lots for item added in recipes
    if ((showInventorySearch || showWipSearch || (isShipmentLog && defaultLabel == "lotcode")) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog 
      //|| (isRecipe && this.props.batchSizeChanged != nextProps.batchSizeChanged)
    ) && !(isRecipe && complete_date)
    ) {
      var sectionComponent = components ? components.find((c, idx) => (c?.type == "section") && (section_id == c.section_id)) : null;
      if (ingredientComponent?.length > 0) {
        var ingredientComponentId = ingredientComponent[0].id;
        if (submission[ingredientComponentId]) {
          if (submission[ingredientComponentId][position]) {
            var ingredientName = submission[ingredientComponentId][position];
            if (ingredientName && (ingredientName != this.state.ingredientName 
              //|| this.props.batchSizeChanged != nextProps.batchSizeChanged
            )) {
              var data = {
                name: ingredientName,
                type: (ingredientComponent[0]?.defaultLabel == "ingredient" || ingredientComponent[0]?.defaultLabel == "itemName") ?
                  showWipSearch ?
                    "wip" : "ingredient" : ((isInventoryTransfer || isShipmentLog) && ingredientComponent[0]?.defaultLabel == "item") ?
                    sectionComponent?.defaultLabel == "finishedGoods" ?
                      "fg" : sectionComponent?.defaultLabel == "workInProgress" ?
                        "wip" : sectionComponent?.defaultLabel == "packagingMaterials" ?
                          "packagingMaterial" : "ingredient" : isInvoice ?
                      "fg" : "packagingMaterial"
              }
              this.setState({ ingredientName });
              if (isRecipe) data.forRecipe = true;
              //if(ingredientOptions.length <= 0)
              this.props.getIngredientLotsByName(data, (res) => {
                
                if (res?.lots?.length) {
                  //if (nextProps.lotcodeFirstPreselection && !isShipmentLog) {
                  //  this.onSelectItem(["default_lot"], true);
                  //}
                  //else{
                  if(!isShipmentLog){
                    var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(res?.lots)));
                    this.onSelectItem(val, true);
                  }
                  //}
                  this.setState({ ingredientOptions: res.lots });
                } else if (res?.lots?.length <= 0 && typeof this.state.value == "object" && this.state.value[0] == "default_lot") {
                  this.setState({ value: "" }, () => onChange(id, ""))
                }
              });
              
            }
          }
        }
      }
    }
    if((isShipmentLog || isRecipe) && this.state.ingredientOptions?.length > 0 && this.props.quantityChanged != nextProps.quantityChanged && ((quantityChangedPosition == position && isShipmentLog) || isRecipe)){
      if(defaultLabel == "lotcode_finished"){
        var actual = getComponentSubmit(submission, components, "quantityFinishedGoods", id, position);
        var past = getComponentSubmit(this.props.submission, components, "quantityFinishedGoods", id, position);
        if(actual != past){
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        }
      }
      if(defaultLabel == "lotcode_wip"){
        var actual = getComponentSubmit(submission, components, "quantityWIP", id, position);
        var past = getComponentSubmit(this.props.submission, components, "quantityWIP", id, position);
        if(actual != past){
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        }
      }
      if(defaultLabel == "lotcode" && isShipmentLog){
        var actual = getComponentSubmit(submission, components, "quantityIngredient", id, position);
        var past = getComponentSubmit(this.props.submission, components, "quantityIngredient", id, position);
        if(actual != past){
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        }
        //Packaging
        actual = getComponentSubmit(submission, components, "quantityPackaging", id, position);
        past = getComponentSubmit(this.props.submission, components, "quantityPackaging", id, position);
        if(actual != past){
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        }
      }

      if(defaultLabel == "lotcode" && isRecipe){
        var actual = getComponentSubmit(submission, components, "quantity", id, position);
        var past = getComponentSubmit(this.props.submission, components, "quantity", id, position);
        if(actual != past){
          var p = (position + 1) * 300;
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.setState({ loadingBatchSizeChange: true });
          setTimeout(() => {
            this.onSelectItem(val, false);
            setTimeout(()=> this.setState({ loadingBatchSizeChange: false }), 200);
          }, p);
        }
      }

    }
  }
  generateLotCode(max, min) {
    const { id, submissionSelected, onChange, lotConsecutive } = this.props;
    var val = submissionSelected?._id ? submissionSelected._id.slice(-8) + lotConsecutive : Math.floor(Math.random() * (max - min) + min);
    onChange(id, val);
    this.setState({ value: val });
  }
  onSelectItem(val, prepopulate) {
    const { onChange, id } = this.props;

    this.setState({ value: val });
    onChange(id, val, prepopulate);
  }
  filllocationFromLotsView(componentId, location) {
    const { components, onChange, id } = this.props;
    var locationComponent = getComponentByanotherComponentId(componentId, "location", components);
    if (locationComponent) {
      onChange(id, location);
    }
  }
  isInventoryForm() {
    const { isRequisitionForm, isShipmentLog, isReceivingLog, isInvoiceForm, isInventoryTransfer, isRecipe } = this.props;
    return (isRequisitionForm || isShipmentLog || isReceivingLog || isInvoiceForm || isInventoryTransfer || isRecipe)
  }
  gotLotDefaultLabel(defaultLabel) {
    return (defaultLabel == "lotcode" || defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip" || defaultLabel == "lot");
  }
  getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes) {
    var quantity = "";
    var units = "";
    var quantityComponent = null;
    var unitsComponent = null;
    unitsComponent = getComponentByanotherComponentId(id, "units", components);

    var preselectedLots = [];
    if (defaultLabel == "lotcode") {
      quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
      if(!quantityComponent && this.props.isShipmentLog)quantityComponent = getComponentByanotherComponentId(id, "quantityIngredient", components);
      if(!quantityComponent && this.props.isShipmentLog)quantityComponent = getComponentByanotherComponentId(id, "quantityPackaging", components);
    }else if(defaultLabel == "lotcode_finished"){
      quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
    }else if(defaultLabel == "lotcode_wip"){
      quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
    }
    if (quantityComponent) {
      quantity = getComponentSubmissionByDefaultLabel(quantityComponent.defaultLabel, components, submission, quantityComponent.section_id, position);
    }
    if(unitsComponent){
      units = getComponentSubmissionByDefaultLabel(unitsComponent?.defaultLabel, components, submission, unitsComponent?.section_id, position);
    }
    if (quantity) quantity = parseFloat(quantity);
    if (quantity > 0) {
      lotCodes.map((lotCode, idx) => {
        if (quantity > 0) {
          if(lotCode?.historial){
            lotCode.historial.map((batch)=>{
                if(quantity > 0){
                    var rest = batch?.amount - quantity;
                    if (rest >= 0) {
                      batch.editedAmount = (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity;
                      quantity = 0;
                    } else {
                      quantity = rest * -1;
                      batch.editedAmount = (batch?.amount % 1 > 0  && !validateDecimals(quantity.toString())) ? parseFloat(batch?.amount).toFixed(3) : parseFloat(batch.amount);
                    }
                }else{
                  batch.hide = true;
                }

                return batch;
            })
          }
          preselectedLots.push(lotCode);
        }
      })
      if (quantity > 0) {
        preselectedLots.push({
          lot: "",
          historial: [],
          minDate: "",
          production_date: "",
          totalAmount: 0,
          editedAmount: (quantity % 1 > 0  && !validateDecimals(quantity.toString())) ?  quantity.toFixed(3) : quantity,
          isNew: true,
          units
        })
      }
    } else {
      preselectedLots = lotCodes?.length ? [lotCodes[0]] : [];
    }
    return preselectedLots;
  }
  getRequiredAmount() {
    const { components, id, position, isRecipe, submission, defaultLabel, defaultYield } = this.props;
    var amount = "";
    var component = components ? components.find((comp) => comp.type != "section" && comp.id == id) : null;
    var section = components ? components.find((comp) => comp.type == "section" && comp.section_id == component?.section_id) : null;

    if (section) {
        var quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
        if(isRecipe){
          if(submission){
            if(quantityComponent)
              amount = getComponentDefaultSubmit(components, submission, defaultLabel, quantityComponent?.id, position, defaultYield);
          }
        }else{
          if(section?.defaultSubmission)
            if (section?.defaultSubmission[quantityComponent?.id]) {
                if (section?.defaultSubmission[quantityComponent?.id][position]) {
                    amount = section.defaultSubmission[quantityComponent.id][position]
                }
            }
        }
    }
    return amount;
  }
  inputBlur(){
    if (this.textInputRef.current) {
      this.setState({leftWriting: true});
      //this.textInputRef.current.blur();
    }
    clearInterval(_interval);
  }
  render() {
    const { value, reset, ingredientOptions, showLotsByLocation, leftWriting, loadingBatchSizeChange } = this.state;
    const { id, onChange, label, customlot, isIssuable, onSubmitIssue, isCompleted, submissionSelected, showLotGenerator, width, openIssue, defaultComponent, showInventorySearch, defaultLabel, isShipmentLog, options, submission, showWipSearch, isRecipe, isInvoice, isInventoryTransfer, openDropDown, backgroundColor, isLast, isDropDownOpened, closeSearch, resetDropDown, position, components, rerenderTable, isInventoryReceivingForm, isReceivingLog } = this.props;
    const type = defaultLabel == "lotcode_finished" ? "Finished goods" : defaultLabel == "lotcode_wip" ? "Work in progress" : showWipSearch ? "Work in progress" : "";
    const requiredAmount = this.getRequiredAmount();
    var ingredientName = "";
    var units = "";
    var amount = "";
    var minorAmount = isRecipe ? (parseFloat(getTotalSelected(value)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(value)) > parseFloat(requiredAmount)) && !loadingBatchSizeChange : false;
    //console.log('minorAmount: ' + minorAmount + " position: " + position + " value: " + getTotalSelected(value) + " requiredAmount " + parseFloat(requiredAmount));
    //console.log(value);
    if (isInventoryReceivingForm) {
      ingredientName = getComponentSubmit(submission, components, "ingredient", id, position);
      if (!ingredientName) ingredientName = getComponentSubmit(submission, components, "name", id, position);
      if (!ingredientName) ingredientName = getComponentSubmit(submission, components, "item", id, position);

      amount = getComponentSubmit(submission, components, "quantity", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityIngredient", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityFinishedGoods", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityWIP", id, position);

      if(typeof amount == "string")amount = formatStringNumber(amount);
      if(amount)amount = parseFloat(amount);
    }
    if (isInventoryReceivingForm) units = getComponentSubmit(submission, components, "units", id, position);
    return (
      <View>
        {((isInventoryReceivingForm) && showLotsByLocation) && <LotsByLocation units={units} amount={amount} lotsSelected={value} options={options ? options : []} id={id} position={position} name={ingredientName} 
          onBack={(editQty, totalSelected, minorAmount) => {
              this.setState({ showLotsByLocation: false });
              if(
                //!isRecipe && 
                onChange && editQty
              ){
                  var quantityComponent = isShipmentLog ? defaultLabel == "lotcode_finished" ? getComponentByanotherComponentId(id, "quantityFinishedGoods", components) : defaultLabel == "lotcode_wip" ? getComponentByanotherComponentId(id, "quantityWIP", components) : getComponentByanotherComponentId(id, "quantityIngredient", components) ?  getComponentByanotherComponentId(id, "quantityIngredient", components) :  getComponentByanotherComponentId(id, "quantityPackaging", components) : getComponentByanotherComponentId(id, "quantity", components);
                  if(quantityComponent)onChange(quantityComponent.id, totalSelected, false);
              }
          }} placeholder={"Search by lot code"} onSelect={(selected, location) => {
              this.onSelectItem(selected, true);
              if(isRecipe)this.filllocationFromLotsView(location)
          }} components={components} openAlert={(value) => this.setState({ showLotsByLocation: !value })} requiredAmount={requiredAmount} isInventoryType={defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip"} isReceivingLog={isReceivingLog} isRecipe={isRecipe} isShipmentLog={isShipmentLog}/>}
        {!width ?
          <NewIssue
            visible={this.state.dialogVisible}
            id={id}
            label={label}
            onSubmitIssue={onSubmitIssue}
            handleClose={() => this.setState({ dialogVisible: false })}
            width={width}
          /> : null
        }

        <View style={styles.container, {
          paddingTop: width ? 0 : 5
        }}>
          {!customlot ?
            <Text style={styles.label}>{label}</Text> : null
          }
          {
            (isIssuable && isCompleted) &&
            <TouchableOpacity style={{ paddingBottom: 10, paddingTop: 5 }} onPress={() => {
              if (width) {
                openIssue();
              } else {
                this.setState({ dialogVisible: true });
              }
            }}>
              <Text style={{ color: colors.primary, fontWeight: 'bold' }}>Issue</Text>
            </TouchableOpacity>
          }
          {
            (showInventorySearch && (!isShipmentLog && !isRecipe && !isInvoice && !isInventoryTransfer)) &&
            <SearchInventory resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} type={type} searchBy={'lot'} isShipmentLog={isShipmentLog} options={options} defaultLabel={defaultLabel} reset={reset} id={id} submission={submission} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch} />
          }
          {/* //For recipes */}
          {
            ((showInventorySearch || (isShipmentLog && defaultLabel == "lotcode")) && (ingredientOptions?.length > 0 && typeof value == "object") && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog)) &&
            <SearchIngredientsByLot resetDropDown={resetDropDown} defaultComponent={defaultComponent} onSelectItem={(val) => {
              if (isRecipe && defaultLabel == "lotcode")
                this.onSelectItem(val, true);
              else
                this.onSelectItem(val);
            }} initial={value} type={type} searchBy={'lot'} isRecipe={isRecipe} isInvoice={isInvoice} isInventoryTransfer={isInventoryTransfer} options={ingredientOptions} defaultLabel={defaultLabel} reset={reset} id={id} submission={submission} width={width} isShipmentLog={isShipmentLog} openDropDown={openDropDown} backgroundColor={backgroundColor} isLast={isLast} isDropDownOpened={isDropDownOpened} closeSearch={closeSearch}
              ingredientName={ingredientName} units={units} amount={amount} rerenderTable={rerenderTable} isInventoryForm={this.isInventoryForm()} gotLotDefaultLabel={this.gotLotDefaultLabel(defaultLabel)} filllocationFromLotsView={(location) => this.filllocationFromLotsView(location)} onChange={onChange} components={components} position={position} minorAmount={minorAmount} requiredAmount={requiredAmount} isInventoryReceivingForm={isInventoryReceivingForm} isReceivingLog={isReceivingLog}/>
          }
          {
            (!(showInventorySearch && (!isShipmentLog && !isRecipe && !isInvoice && !isInventoryTransfer)) &&
              !((showInventorySearch || (isShipmentLog && defaultLabel == "lotcode")) && (ingredientOptions?.length > 0 && typeof value == "object") && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog))) &&
            <div style={{
              border: (isRecipe && defaultLabel == "lot") ? ('solid 1px ' + colors.orange) : "none",
              borderRadius: (isInventoryReceivingForm && defaultLabel != "lot") ? 20 : (isRecipe && defaultLabel == "lot") ? 10 : 0,
              marginTop: (isRecipe && defaultLabel == "lot") ? 15 : 0,
              padding: (isRecipe && defaultLabel == "lot") ? 5 : 0,
              marginInline: (isRecipe && defaultLabel == "lot") ? 5 : 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: (isInventoryReceivingForm && defaultLabel != "lot") ? typeof value == "object" && minorAmount ? colors.quit : colors.primary : 'none',
            }}>
              <TextInput
                value={typeof value == "string" ? value : typeof value == "object" ? getLotCodeString(value) : ""}
                editable={!defaultComponent && !(isRecipe && ingredientName.trim().toLowerCase() == "water")}
                ref={this.textInputRef}
                onContentSizeChange={(event) => {
                  if (event.nativeEvent.contentSize.height == 0) {
                    if (this.props.placeholder == '') {
                      this.setState({ height: 30 })
                    }
                    this.setState({ height: event.nativeEvent.contentSize.height });
                  } else {
                    setTimeout(() => {
                      this.setState({ height: event.nativeEvent.contentSize.height });
                    }, 5)
                  }
                }}
                onFocus={()=> {
                  if((isInventoryReceivingForm) && value && leftWriting && defaultLabel != "lot"){
                      this.setState({ showLotsByLocation: true }, () =>{
                          if (this.textInputRef.current) {
                            this.textInputRef.current.blur();
                          }
                      });
                  }
                }}
                style={{
                  borderColor: (isInventoryReceivingForm && defaultLabel == "lot") ? colors.orange : "#e7e7e7",
                  borderRadius: (isInventoryReceivingForm && defaultLabel != "lot") ? 20 : (isInventoryReceivingForm && defaultLabel == "lot") ? 10 : 5,
                  borderWidth: ((isInventoryReceivingForm && width)) ? 0 : 1,
                  color: isInventoryReceivingForm ? defaultLabel == "lot" ? colors.orange : 'white' : "#424242",
                  fontFamily: "Roboto",
                  fontSize: isInventoryReceivingForm ? 14 : 20,
                  fontWeight: "400",
                  padding: 5,
                  height: this.state.height,
                  fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
                  overflow: 'hidden',
                  marginTop: (isInventoryReceivingForm && defaultLabel == "lot") ? 10 : isInventoryReceivingForm ? 0 : 5,
                  textAlign: isInventoryReceivingForm ? 'center' : 'left',
                  backgroundColor: (isInventoryReceivingForm && defaultLabel != "lot") ? typeof value == "object" && minorAmount ? colors.quit : colors.primary : 'none',
                  cursor: value ? 'pointer' : 'auto'
                }}
                multiline={true}
                placeholder={this.props.placeholder ? this.props.placeholder : ""}
                placeholderTextColor={'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                  this.setState({  leftWriting: false});
                  if(isInventoryReceivingForm && defaultLabel != "lot"){
                    clearInterval(_interval);
                    _interval = setInterval(() => this.inputBlur(), 500);
                  }

                  if (val == '' && this.props.placeholder == '') {
                    this.setState({ value: val, height: 30 });

                  } else {
                    this.setState({ value: val });

                  }
                  onChange(id, val);
                }}

              />
              {
                  isInventoryReceivingForm && typeof value == "object" && value?.length > 1 && <Text style={styles.lotsSelectedViewTxt}>+{value?.length - 1}</Text>
              }
            </div>

          }
          {
            showLotGenerator &&
            <TouchableOpacity style={styles.btnLotCode} onPress={() => { this.generateLotCode(999999999999, 10000000) }}>
              <Text style={styles.txtLotCode}>Generate Lot Code</Text>
            </TouchableOpacity>
          }
        </View>
      </View>
    );
  }
}
export default connect((state, ownProps = {}) => ({
}), (dispatch, props) => ({
  getIngredientLotsByName: (data, callback) => {
    dispatch(getIngredientLotsByName(data, callback));
  },
  dispatch: dispatch,
}))(LotCode);

const styles = StyleSheet.create({
  container: {
    alignSelf: "stretch",
    alignItems: "stretch",
    flexDirection: "column",
    // paddingLeft: 10,
    // paddingRight: 10,
    paddingTop: 5,
    // paddingBottom: 10,
  },
  input: {
    fontSize: 22,
    color: "#424242",
    fontWeight: "400",
    alignSelf: "stretch",
    height: 50,
    flex: 1,
    borderStyle: "solid",
    borderColor: "#e7e7e7",
    borderWidth: 1,
    borderRadius: 5,
    paddingLeft: 10,
    fontFamily: "Roboto",
  },
  label: {
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  btnLotCode: {
    padding: 10,
    textAlign: "center",
    marginTop: 10,
    borderRadius: 5,
    backgroundColor: colors.primary
  },
  txtLotCode: {
    color: 'white',
    fontSize: 18
  },
  lotsSelectedViewTxt:{
      color: 'white',
      borderWidth: 1,
      borderRadius: 5,
      padding: 2,
      borderColor: 'white',
      fontSize: 12,
      height: 20,
      marginRight: 10,
  },
});
